import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import Button from '../../atomicComponents/Button/Button';
import styles from './BackButton.module.css';
import ArrowBackIcon from '../../assets/icons/ArrowBackIcon';
import BrowserBackModal from '../../components/FormComponents/BrowserBackModal';

export default function BackButton({ action, handleClick, userMaterialGroups, basePath, materialGroup, isbulkDownloaded, bulkSearchButton, data }) {
    const [modal, setModal] = useState(false);
    const back = (isbulkDownloaded, bulkSearchButton, handleClick) => {
        if (!isbulkDownloaded && bulkSearchButton && data?.length > 0) {
            setModal(true)
        }
        else {
            handleClick();
        }
    }
    const closeModal = () => {
        setModal(false)
    }
    return (
        <>
            <Button style={{ padding: '1px 0 2px 0' }} className={styles.backButton} onClick={() => back(isbulkDownloaded, bulkSearchButton, handleClick)}>
                <ArrowBackIcon className={styles.arrowBackIcon} />
                {basePath && (
                    <span className={styles.materialGroup}>{basePath}</span>
                )
                }
                {(basePath) && (
                    <span className={styles.action}>/</span>
                )}
                <span className={styles.action} data-testid={action}>
                    {action}
                </span>
            </Button>
            <BrowserBackModal handleClose={() => closeModal()} open={modal} confirm={handleClick} />
        </>
    )
}

export { BackButton as BaseBackButton };
// eslint-disable-next-line import/prefer-default-export